import request from "library/v1/request";

export function authenticate(data) {
  return request({
    url: `/session/token`,
    method: 'post',
    data: data,
    params: {
      skipAuth: true
    }
  });
}
